import { EvaluationEvent } from '@keyops-cep/api-client';
import { useQuery } from '@tanstack/react-query';

import { getAllEvaluationEvents } from '../api/evaluation-event.functions';

export const useGetAllEvaluationEvents = () => {
  return useQuery<EvaluationEvent[]>({
    queryKey: ['get-all-evaluation-events'],
    queryFn: () => getAllEvaluationEvents(),
  });
};
